import {
    Calendar,
    Clock,
    MapPin,
} from "lucide-react";

import {
    DateTime,
} from "luxon";

import {

    formatDisplayDate,

    BUSINESS_TZ,

    getTodayET,

} from "../../utils/timeUtils";

import {
    SPORT_CONFIG,
} from "../../utils/orderUtils";

function UpcomingBookingCard({
    slot,
}) {

    /* ---------------------------------- */
    /* SLOT TIME IN ET */
    /* ---------------------------------- */

    const slotDateTime =
        DateTime.fromISO(

            `${slot.date}T${String(slot.startHour || 0).padStart(2, "0")}:00:00`,

            {
                zone:
                    BUSINESS_TZ,
            }
        );

    const todayET =
        getTodayET();

    const isToday =
        slot.date ===
        todayET;

    const daysUntil =
        Math.ceil(

            slotDateTime
                .startOf("day")
                .diffNow("days")
                .days
        );

    const sportConfig =
        SPORT_CONFIG[
        slot.sport
        ];

    return (

        <div style={styles.card}>

            {/* TOP */}

            <div style={styles.topSection}>

                <div>

                    <h2 style={styles.courtName}>
                        {slot.courtName}
                    </h2>

                    {sportConfig && (

                        <div
                            style={{
                                ...styles.sportBadge,

                                color:
                                    sportConfig.color,

                                border:
                                    `1px solid ${sportConfig.color}40`,

                                background:
                                    `${sportConfig.color}15`,
                            }}
                        >

                            {sportConfig.emoji}

                            {" "}

                            {sportConfig.label}

                        </div>
                    )}

                </div>

                <div style={styles.badges}>

                    {isToday && (

                        <div
                            style={{
                                ...styles.dayBadge,

                                background:
                                    "rgba(0,255,136,0.15)",

                                border:
                                    "1px solid rgba(0,255,136,0.35)",

                                color:
                                    "#00ff88",
                            }}
                        >

                            Today

                        </div>
                    )}

                    {!isToday &&
                        daysUntil >= 0 && (

                            <div
                                style={{
                                    ...styles.dayBadge,

                                    background:
                                        "rgba(0,212,255,0.14)",

                                    border:
                                        "1px solid rgba(0,212,255,0.35)",

                                    color:
                                        "#00d4ff",
                                }}
                            >

                                In {daysUntil} day
                                {daysUntil !== 1
                                    ? "s"
                                    : ""}

                            </div>
                        )}

                </div>

            </div>

            {/* META */}

            <div style={styles.metaGrid}>

                <div style={styles.metaItem}>

                    <Calendar
                        size={14}
                    />

                    <span>

                        {formatDisplayDate(
                            slot.date
                        )}

                    </span>

                </div>

                <div style={styles.metaItem}>

                    <Clock
                        size={14}
                    />

                    <span>

                        {slot.timeSlot}

                        {" "}

                        (

                        {slot.duration}h

                        )

                    </span>

                </div>

                <div style={styles.metaItem}>

                    <MapPin
                        size={14}
                    />

                    <span>
                        {slot.location}
                    </span>

                </div>

            </div>

        </div>
    );
}

const styles = {

    card: {

        background:
            "rgba(0,40,70,0.72)",

        border:
            "1px solid rgba(0,255,136,0.15)",

        borderRadius:
            "24px",

        padding:
            "24px",

        backdropFilter:
            "blur(10px)",
    },

    topSection: {

        display:
            "flex",

        justifyContent:
            "space-between",

        alignItems:
            "flex-start",

        gap:
            "20px",

        marginBottom:
            "20px",

        flexWrap:
            "wrap",
    },

    badges: {

        display:
            "flex",

        gap:
            "10px",

        flexWrap:
            "wrap",
    },

    dayBadge: {

        padding:
            "6px 12px",

        borderRadius:
            "999px",

        fontSize:
            "12px",

        fontWeight:
            "700",
    },

    courtName: {

        color:
            "#fff",

        margin:
            0,

        marginBottom:
            "10px",

        fontSize:
            "24px",

        fontWeight:
            "800",
    },

    sportBadge: {

        display:
            "inline-flex",

        alignItems:
            "center",

        gap:
            "6px",

        padding:
            "6px 12px",

        borderRadius:
            "999px",

        fontSize:
            "12px",

        fontWeight:
            "700",
    },

    metaGrid: {

        display:
            "grid",

        gridTemplateColumns:
            "repeat(auto-fit, minmax(180px, 1fr))",

        gap:
            "12px",

        marginBottom:
            "4px",
    },

    metaItem: {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "8px",

        color:
            "#d1d5db",

        fontSize:
            "14px",
    },

    actions: {

        display:
            "flex",

        gap:
            "14px",

        flexWrap:
            "wrap",
    },

    rescheduleButton: {

        flex:
            1,

        minWidth:
            "180px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        gap:
            "8px",

        padding:
            "14px",

        borderRadius:
            "14px",

        border:
            "1px solid rgba(0,255,136,0.18)",

        background:
            "rgba(255,255,255,0.05)",

        color:
            "#fff",

        cursor:
            "pointer",

        fontWeight:
            "700",
    },

    cancelButton: {

        flex:
            1,

        minWidth:
            "180px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        gap:
            "8px",

        padding:
            "14px",

        borderRadius:
            "14px",

        border:
            "1px solid rgba(255,80,80,0.25)",

        background:
            "rgba(255,80,80,0.12)",

        color:
            "#ff7b7b",

        cursor:
            "pointer",

        fontWeight:
            "700",
    },

    policyBox: {

        marginTop:
            "18px",

        padding:
            "14px",

        borderRadius:
            "14px",

        background:
            "rgba(0,212,255,0.08)",

        border:
            "1px solid rgba(0,212,255,0.18)",

        color:
            "#d1d5db",

        fontSize:
            "13px",
    },
};

export default UpcomingBookingCard;